import styled from 'styled-components'
import { Modal as AntModal } from 'antd'

export const StyledModal = styled(AntModal)`
  &.ant-modal {
    overflow: hidden;
  }
`
